
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            当店のこだわり
            <span className="ml-3 text-amber-600">☕</span>
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
            築100年の町家を改装し、木の温もりと伝統の趣を大切にした空間で、<br />
            心安らぐひとときをお過ごしいただけます
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 自家焙煎カード - 幅広・展開状態 */}
          <div className="md:col-span-2 group">
            <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500">
              <img
                src="https://public.readdy.ai/ai/img_res/3bb5ee0c9924ae8b185db73bd5b1b8a8.jpg"
                alt="自家焙煎の様子"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  自家焙煎へのこだわり
                </h3>
                <p className="text-amber-200">
                  毎朝店内で焙煎する新鮮な豆
                </p>
              </div>
            </div>
          </div>

          {/* 町家の趣カード */}
          <div className="group">
            <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20Japanese%20machiya%20architecture%20interior%2C%20wooden%20beams%2C%20tatami%20mats%2C%20shoji%20screens%2C%20natural%20wood%20grain%20textures%2C%20warm%20ambient%20lighting%2C%20traditional%20Japanese%20design%20elements%2C%20peaceful%20atmosphere&width=600&height=800&seq=machiya-interior&orientation=portrait"
                alt="町家の内装"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-6 left-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  町家の趣
                </h3>
                <p className="text-amber-200 text-sm">
                  築100年の町家をリノベーション
                </p>
              </div>
            </div>
          </div>

          {/* 季節の味わいカード */}
          <div className="group">
            <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20Japanese%20sweets%20and%20coffee%20arrangement%20on%20wooden%20table%2C%20wagashi%20traditional%20confectionery%2C%20ceramic%20coffee%20cups%2C%20seasonal%20ingredients%2C%20elegant%20presentation%2C%20warm%20wooden%20background&width=600&height=800&seq=seasonal-sweets&orientation=portrait"
                alt="季節の和菓子とコーヒー"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-6 left-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  季節の味わい
                </h3>
                <p className="text-amber-200 text-sm">
                  厳選した季節の食材を使用
                </p>
              </div>
            </div>
          </div>

          {/* データ表示カード */}
          <div className="md:col-span-2 bg-white rounded-2xl shadow-lg p-8">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-bold text-amber-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  お客様に愛されて
                </h3>
                <div className="grid grid-cols-3 gap-6">
                  <div className="text-center border-r border-amber-200">
                    <div className="text-3xl font-bold text-amber-700 mb-2">30+</div>
                    <div className="text-sm text-gray-600">年の歴史</div>
                  </div>
                  <div className="text-center border-r border-amber-200">
                    <div className="text-3xl font-bold text-amber-700 mb-2">150+</div>
                    <div className="text-sm text-gray-600">種類の豆</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-amber-700 mb-2">5000+</div>
                    <div className="text-sm text-gray-600">杯/月の提供</div>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-br from-amber-100 to-orange-100 rounded-xl p-6 flex items-center justify-center">
                <div className="w-32 h-32 bg-gradient-to-br from-amber-300/30 to-orange-300/30 rounded-full flex items-center justify-center">
                  <i className="ri-cup-line text-4xl text-amber-700"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
